import ReviewQuery from 'Query/Review.query';
import { ReviewDispatcher as SourceReviewDispatcher } from 'SourceStore/Review/Review.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { fetchMutation } from 'Util/Request';

/** @namespace Pwa/Store/Review/Dispatcher */
export class ReviewDispatcher extends SourceReviewDispatcher {
    async submitProductReview(dispatch, options) {
        await fetchMutation(ReviewQuery.getAddProductReviewMutation(this.prepareReviewData(options)));
        dispatch(showNotification('success', __('You submitted your review for moderation.')));
    }
}

export default new ReviewDispatcher();
